import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3 md:mb-8">
      <div>
        <div className="flex items-center gap-2.5">
          <span className="h-5 w-1 rounded-full bg-accent-500 md:h-6" aria-hidden="true"></span>
          <h2 className="font-heading text-xl font-extrabold tracking-tight text-foreground-950 md:text-2xl">
            {title}
          </h2>
        </div>
        {subtitle && <p className="mt-2 text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="group flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 py-1.5 text-xs font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 md:text-sm"
        >
          {moreLabel}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" aria-hidden="true"></i>
        </Link>
      )}
    </div>
  );
}